import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__index" */ '../../layouts/index.js'),
        })
      : require('../../layouts/index.js').default,
    routes: [
      {
        path: '/404',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404.js'),
            })
          : require('../404.js').default,
      },
      {
        path: '/about',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__about__index" */ '../about/index.js'),
            })
          : require('../about/index.js').default,
      },
      {
        path: '/acts/addDevice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__addDevice__index" */ '../acts/addDevice/index.js'),
            })
          : require('../acts/addDevice/index.js').default,
      },
      {
        path: '/acts/auth',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__auth" */ '../acts/auth.js'),
            })
          : require('../acts/auth.js').default,
      },
      {
        path: '/acts/bindDevice/invitee',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__bindDevice__invitee" */ '../acts/bindDevice/invitee.js'),
            })
          : require('../acts/bindDevice/invitee.js').default,
      },
      {
        path: '/acts/bindDevice/uninvited',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__bindDevice__uninvited" */ '../acts/bindDevice/uninvited.js'),
            })
          : require('../acts/bindDevice/uninvited.js').default,
      },
      {
        path: '/acts/blackDevice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__blackDevice__index" */ '../acts/blackDevice/index.js'),
            })
          : require('../acts/blackDevice/index.js').default,
      },
      {
        path: '/acts/cloudbean/pr',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__cloudbean__pr__index" */ '../acts/cloudbean/pr/index.js'),
            })
          : require('../acts/cloudbean/pr/index.js').default,
      },
      {
        path: '/acts/hardwareRecall',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__hardwareRecall__index" */ '../acts/hardwareRecall/index.js'),
            })
          : require('../acts/hardwareRecall/index.js').default,
      },
      {
        path: '/acts/invite-lottery/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__invite-lottery__config" */ '../acts/invite-lottery/config.js'),
            })
          : require('../acts/invite-lottery/config.js').default,
      },
      {
        path: '/acts/invite-lottery',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__invite-lottery__index" */ '../acts/invite-lottery/index.js'),
            })
          : require('../acts/invite-lottery/index.js').default,
      },
      {
        path: '/acts/inviteV2',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__inviteV2" */ '../acts/inviteV2.js'),
            })
          : require('../acts/inviteV2.js').default,
      },
      {
        path: '/acts/loading',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__loading" */ '../acts/loading.js'),
            })
          : require('../acts/loading.js').default,
      },
      {
        path: '/acts/newcomer/welfareA',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__newcomer__welfareA" */ '../acts/newcomer/welfareA.js'),
            })
          : require('../acts/newcomer/welfareA.js').default,
      },
      {
        path: '/acts/newcomer/welfareB',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__newcomer__welfareB" */ '../acts/newcomer/welfareB.js'),
            })
          : require('../acts/newcomer/welfareB.js').default,
      },
      {
        path: '/acts/newuser',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__newuser" */ '../acts/newuser.js'),
            })
          : require('../acts/newuser.js').default,
      },
      {
        path: '/acts/ninthAnniversary/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__config" */ '../acts/ninthAnniversary/config.js'),
            })
          : require('../acts/ninthAnniversary/config.js').default,
      },
      {
        path: '/acts/ninthAnniversary/detail/:deviceID',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__detail___deviceID" */ '../acts/ninthAnniversary/detail/$deviceID.js'),
            })
          : require('../acts/ninthAnniversary/detail/$deviceID.js').default,
      },
      {
        path: '/acts/ninthAnniversary/list/conmponents/EmptyList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__conmponents__EmptyList" */ '../acts/ninthAnniversary/list/conmponents/EmptyList.js'),
            })
          : require('../acts/ninthAnniversary/list/conmponents/EmptyList.js')
              .default,
      },
      {
        path: '/acts/ninthAnniversary/list/conmponents/LoadingList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__conmponents__LoadingList" */ '../acts/ninthAnniversary/list/conmponents/LoadingList.js'),
            })
          : require('../acts/ninthAnniversary/list/conmponents/LoadingList.js')
              .default,
      },
      {
        path:
          '/acts/ninthAnniversary/list/conmponents/NinthAnniversaryDeviceList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__conmponents__NinthAnniversaryDeviceList" */ '../acts/ninthAnniversary/list/conmponents/NinthAnniversaryDeviceList.js'),
            })
          : require('../acts/ninthAnniversary/list/conmponents/NinthAnniversaryDeviceList.js')
              .default,
      },
      {
        path: '/acts/ninthAnniversary/list/conmponents/NotLoginedBlock',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__conmponents__NotLoginedBlock" */ '../acts/ninthAnniversary/list/conmponents/NotLoginedBlock.js'),
            })
          : require('../acts/ninthAnniversary/list/conmponents/NotLoginedBlock.js')
              .default,
      },
      {
        path: '/acts/ninthAnniversary/list/conmponents/RecommendDevicelist',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__conmponents__RecommendDevicelist" */ '../acts/ninthAnniversary/list/conmponents/RecommendDevicelist.js'),
            })
          : require('../acts/ninthAnniversary/list/conmponents/RecommendDevicelist.js')
              .default,
      },
      {
        path: '/acts/ninthAnniversary/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__ninthAnniversary__list__index" */ '../acts/ninthAnniversary/list/index.js'),
            })
          : require('../acts/ninthAnniversary/list/index.js').default,
      },
      {
        path: '/acts/operation',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__operation" */ '../acts/operation.js'),
            })
          : require('../acts/operation.js').default,
      },
      {
        path: '/acts/popup/:popupid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__popup___popupid" */ '../acts/popup/$popupid.js'),
            })
          : require('../acts/popup/$popupid.js').default,
      },
      {
        path: '/acts/product',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__product" */ '../acts/product.js'),
            })
          : require('../acts/product.js').default,
      },
      {
        path: '/acts/recall',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__recall__index" */ '../acts/recall/index.js'),
            })
          : require('../acts/recall/index.js').default,
      },
      {
        path: '/acts/recallDevice/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__recallDevice__config" */ '../acts/recallDevice/config.js'),
            })
          : require('../acts/recallDevice/config.js').default,
      },
      {
        path: '/acts/recallDevice/container',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__recallDevice__container" */ '../acts/recallDevice/container.js'),
            })
          : require('../acts/recallDevice/container.js').default,
      },
      {
        path: '/acts/recallDevice/nas',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__recallDevice__nas" */ '../acts/recallDevice/nas.js'),
            })
          : require('../acts/recallDevice/nas.js').default,
      },
      {
        path: '/acts/rules/addDevice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__addDevice" */ '../acts/rules/addDevice.js'),
            })
          : require('../acts/rules/addDevice.js').default,
      },
      {
        path: '/acts/rules/bindDevice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__bindDevice" */ '../acts/rules/bindDevice.js'),
            })
          : require('../acts/rules/bindDevice.js').default,
      },
      {
        path: '/acts/rules/splitCash',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__splitCash" */ '../acts/rules/splitCash.js'),
            })
          : require('../acts/rules/splitCash.js').default,
      },
      {
        path: '/acts/rules/splitCloudBean',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__splitCloudBean" */ '../acts/rules/splitCloudBean.js'),
            })
          : require('../acts/rules/splitCloudBean.js').default,
      },
      {
        path: '/acts/rules/userLevel',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__userLevel" */ '../acts/rules/userLevel.js'),
            })
          : require('../acts/rules/userLevel.js').default,
      },
      {
        path: '/acts/rules/yundouLottery',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__rules__yundouLottery" */ '../acts/rules/yundouLottery.js'),
            })
          : require('../acts/rules/yundouLottery.js').default,
      },
      {
        path: '/acts/sale618',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__sale618" */ '../acts/sale618.js'),
            })
          : require('../acts/sale618.js').default,
      },
      {
        path: '/acts/splitCash',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__splitCash__index" */ '../acts/splitCash/index.js'),
            })
          : require('../acts/splitCash/index.js').default,
      },
      {
        path: '/acts/splitCash/rank',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__splitCash__rank" */ '../acts/splitCash/rank.js'),
            })
          : require('../acts/splitCash/rank.js').default,
      },
      {
        path: '/acts/splitCloudBean',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__splitCloudBean__index" */ '../acts/splitCloudBean/index.js'),
            })
          : require('../acts/splitCloudBean/index.js').default,
      },
      {
        path: '/acts/splitCloudBean/rank',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__splitCloudBean__rank" */ '../acts/splitCloudBean/rank.js'),
            })
          : require('../acts/splitCloudBean/rank.js').default,
      },
      {
        path: '/acts/x86-addDevice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice__index" */ '../acts/x86-addDevice/index.js'),
            })
          : require('../acts/x86-addDevice/index.js').default,
      },
      {
        path: '/acts/x86-addDevice10/config/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice10__config__config" */ '../acts/x86-addDevice10/config/config.js'),
            })
          : require('../acts/x86-addDevice10/config/config.js').default,
      },
      {
        path: '/acts/x86-addDevice10',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice10__index" */ '../acts/x86-addDevice10/index.js'),
            })
          : require('../acts/x86-addDevice10/index.js').default,
      },
      {
        path: '/acts/x86-addDevice11/config/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice11__config__config" */ '../acts/x86-addDevice11/config/config.js'),
            })
          : require('../acts/x86-addDevice11/config/config.js').default,
      },
      {
        path: '/acts/x86-addDevice11',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice11__index" */ '../acts/x86-addDevice11/index.js'),
            })
          : require('../acts/x86-addDevice11/index.js').default,
      },
      {
        path: '/acts/x86-addDevice3',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice3__index" */ '../acts/x86-addDevice3/index.js'),
            })
          : require('../acts/x86-addDevice3/index.js').default,
      },
      {
        path: '/acts/x86-addDevice3/more',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice3__more" */ '../acts/x86-addDevice3/more.js'),
            })
          : require('../acts/x86-addDevice3/more.js').default,
      },
      {
        path: '/acts/x86-addDevice4',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice4__index" */ '../acts/x86-addDevice4/index.js'),
            })
          : require('../acts/x86-addDevice4/index.js').default,
      },
      {
        path: '/acts/x86-addDevice4/more',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice4__more" */ '../acts/x86-addDevice4/more.js'),
            })
          : require('../acts/x86-addDevice4/more.js').default,
      },
      {
        path: '/acts/x86-addDevice5',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice5__index" */ '../acts/x86-addDevice5/index.js'),
            })
          : require('../acts/x86-addDevice5/index.js').default,
      },
      {
        path: '/acts/x86-addDevice5/more',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice5__more" */ '../acts/x86-addDevice5/more.js'),
            })
          : require('../acts/x86-addDevice5/more.js').default,
      },
      {
        path: '/acts/x86-addDevice6',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice6__index" */ '../acts/x86-addDevice6/index.js'),
            })
          : require('../acts/x86-addDevice6/index.js').default,
      },
      {
        path: '/acts/x86-addDevice6/more',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice6__more" */ '../acts/x86-addDevice6/more.js'),
            })
          : require('../acts/x86-addDevice6/more.js').default,
      },
      {
        path: '/acts/x86-addDevice7',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice7__index" */ '../acts/x86-addDevice7/index.js'),
            })
          : require('../acts/x86-addDevice7/index.js').default,
      },
      {
        path: '/acts/x86-addDevice7/more',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice7__more" */ '../acts/x86-addDevice7/more.js'),
            })
          : require('../acts/x86-addDevice7/more.js').default,
      },
      {
        path: '/acts/x86-addDevice8/config/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice8__config__config" */ '../acts/x86-addDevice8/config/config.js'),
            })
          : require('../acts/x86-addDevice8/config/config.js').default,
      },
      {
        path: '/acts/x86-addDevice8',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice8__index" */ '../acts/x86-addDevice8/index.js'),
            })
          : require('../acts/x86-addDevice8/index.js').default,
      },
      {
        path: '/acts/x86-addDevice9/config/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice9__config__config" */ '../acts/x86-addDevice9/config/config.js'),
            })
          : require('../acts/x86-addDevice9/config/config.js').default,
      },
      {
        path: '/acts/x86-addDevice9',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__x86-addDevice9__index" */ '../acts/x86-addDevice9/index.js'),
            })
          : require('../acts/x86-addDevice9/index.js').default,
      },
      {
        path: '/acts/xlvip/constants',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__xlvip__constants" */ '../acts/xlvip/constants.js'),
            })
          : require('../acts/xlvip/constants.js').default,
      },
      {
        path: '/acts/xlvip/detail/:deviceID',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__xlvip__detail___deviceID" */ '../acts/xlvip/detail/$deviceID.js'),
            })
          : require('../acts/xlvip/detail/$deviceID.js').default,
      },
      {
        path: '/acts/xlvip/nasRewardList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__xlvip__nasRewardList__index" */ '../acts/xlvip/nasRewardList/index.js'),
            })
          : require('../acts/xlvip/nasRewardList/index.js').default,
      },
      {
        path: '/acts/xlvip/summary',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__xlvip__summary__index" */ '../acts/xlvip/summary/index.js'),
            })
          : require('../acts/xlvip/summary/index.js').default,
      },
      {
        path: '/acts/yundouLottery/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__yundouLottery__config__index" */ '../acts/yundouLottery/config/index.js'),
            })
          : require('../acts/yundouLottery/config/index.js').default,
      },
      {
        path: '/acts/yundouLottery',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts__yundouLottery__index" */ '../acts/yundouLottery/index.js'),
            })
          : require('../acts/yundouLottery/index.js').default,
      },
      {
        path: '/acts/:customerType/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts___customerType__config__index" */ '../acts/$customerType/config/index.js'),
            })
          : require('../acts/$customerType/config/index.js').default,
      },
      {
        path: '/acts/:customerType',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__acts___customerType__index" */ '../acts/$customerType/index.js'),
            })
          : require('../acts/$customerType/index.js').default,
      },
      {
        path: '/addDevice/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__addDevice__models__addDevice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/addDevice/models/addDevice.js').then(
                  m => {
                    return { namespace: 'addDevice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__addDevice__config" */ '../addDevice/config.js'),
            })
          : require('../addDevice/config.js').default,
      },
      {
        path: '/addDevice/softnode',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__addDevice__models__addDevice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/addDevice/models/addDevice.js').then(
                  m => {
                    return { namespace: 'addDevice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__addDevice__softnode__index" */ '../addDevice/softnode/index.js'),
            })
          : require('../addDevice/softnode/index.js').default,
      },
      {
        path: '/agreement/app-permission',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__app-permission" */ '../agreement/app-permission.js'),
            })
          : require('../agreement/app-permission.js').default,
      },
      {
        path: '/agreement/auth',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__auth" */ '../agreement/auth.js'),
            })
          : require('../agreement/auth.js').default,
      },
      {
        path: '/agreement/brief-privacy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__brief-privacy" */ '../agreement/brief-privacy.js'),
            })
          : require('../agreement/brief-privacy.js').default,
      },
      {
        path: '/agreement/cloud-account',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__cloud-account" */ '../agreement/cloud-account.js'),
            })
          : require('../agreement/cloud-account.js').default,
      },
      {
        path: '/agreement/confirm',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__confirm" */ '../agreement/confirm.js'),
            })
          : require('../agreement/confirm.js').default,
      },
      {
        path: '/agreement/info-collect',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__info-collect" */ '../agreement/info-collect.js'),
            })
          : require('../agreement/info-collect.js').default,
      },
      {
        path: '/agreement/info-share',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__info-share" */ '../agreement/info-share.js'),
            })
          : require('../agreement/info-share.js').default,
      },
      {
        path: '/agreement/invite',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__invite" */ '../agreement/invite.js'),
            })
          : require('../agreement/invite.js').default,
      },
      {
        path: '/agreement/invitev2/newuser',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__invitev2__newuser" */ '../agreement/invitev2/newuser.js'),
            })
          : require('../agreement/invitev2/newuser.js').default,
      },
      {
        path: '/agreement/invitev2/olduser',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__invitev2__olduser" */ '../agreement/invitev2/olduser.js'),
            })
          : require('../agreement/invitev2/olduser.js').default,
      },
      {
        path: '/agreement/logout',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__logout" */ '../agreement/logout.js'),
            })
          : require('../agreement/logout.js').default,
      },
      {
        path: '/agreement/luopan',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__luopan" */ '../agreement/luopan.js'),
            })
          : require('../agreement/luopan.js').default,
      },
      {
        path: '/agreement/privacy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__privacy" */ '../agreement/privacy.js'),
            })
          : require('../agreement/privacy.js').default,
      },
      {
        path: '/agreement/user',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__user" */ '../agreement/user.js'),
            })
          : require('../agreement/user.js').default,
      },
      {
        path: '/agreement/withdraw',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__withdraw__index" */ '../agreement/withdraw/index.js'),
            })
          : require('../agreement/withdraw/index.js').default,
      },
      {
        path: '/agreement/withdraw/instructions',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__agreement__withdraw__instructions" */ '../agreement/withdraw/instructions.js'),
            })
          : require('../agreement/withdraw/instructions.js').default,
      },
      {
        path: '/app/agreement/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__app__agreement__models__index.ts' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/app/agreement/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__app__agreement__config__index" */ '../app/agreement/config/index.ts'),
            })
          : require('../app/agreement/config/index.ts').default,
      },
      {
        path: '/app/agreement/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__app__agreement__models__index.ts' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/app/agreement/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__app__agreement__detail__index" */ '../app/agreement/detail/index.js'),
            })
          : require('../app/agreement/detail/index.js').default,
      },
      {
        path: '/assisted/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__assisted__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/assisted/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__assisted__config__index" */ '../assisted/config/index.js'),
            })
          : require('../assisted/config/index.js').default,
      },
      {
        path: '/assisted/rewardList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__assisted__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/assisted/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__assisted__rewardList__index" */ '../assisted/rewardList/index.js'),
            })
          : require('../assisted/rewardList/index.js').default,
      },
      {
        path: '/auth/choose',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__choose__index" */ '../auth/choose/index.js'),
            })
          : require('../auth/choose/index.js').default,
      },
      {
        path: '/auth/common',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__common__index" */ '../auth/common/index.js'),
            })
          : require('../auth/common/index.js').default,
      },
      {
        path: '/auth/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__config" */ '../auth/config.js'),
            })
          : require('../auth/config.js').default,
      },
      {
        path: '/auth/enterprise',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__enterprise__index" */ '../auth/enterprise/index.js'),
            })
          : require('../auth/enterprise/index.js').default,
      },
      {
        path: '/auth/notice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__notice" */ '../auth/notice.js'),
            })
          : require('../auth/notice.js').default,
      },
      {
        path: '/auth/personal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__personal" */ '../auth/personal.js'),
            })
          : require('../auth/personal.js').default,
      },
      {
        path: '/auth/personalAlipay',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__personalAlipay__index" */ '../auth/personalAlipay/index.js'),
            })
          : require('../auth/personalAlipay/index.js').default,
      },
      {
        path: '/auth/personalBank',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__personalBank__index" */ '../auth/personalBank/index.js'),
            })
          : require('../auth/personalBank/index.js').default,
      },
      {
        path: '/auth/resultClear',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__resultClear__index" */ '../auth/resultClear/index.js'),
            })
          : require('../auth/resultClear/index.js').default,
      },
      {
        path: '/auth/resultList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__auth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/auth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__auth__resultList__index" */ '../auth/resultList/index.js'),
            })
          : require('../auth/resultList/index.js').default,
      },
      {
        path: '/bandwidth/const',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__bandwidth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/bandwidth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bandwidth__const__index" */ '../bandwidth/const/index.js'),
            })
          : require('../bandwidth/const/index.js').default,
      },
      {
        path: '/bandwidth/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__bandwidth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/bandwidth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bandwidth__record" */ '../bandwidth/record.js'),
            })
          : require('../bandwidth/record.js').default,
      },
      {
        path: '/bandwidth/:reportid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__bandwidth__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/bandwidth/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bandwidth___reportid" */ '../bandwidth/$reportid.js'),
            })
          : require('../bandwidth/$reportid.js').default,
      },
      {
        path: '/customerService/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__config__index" */ '../customerService/config/index.js'),
            })
          : require('../customerService/config/index.js').default,
      },
      {
        path: '/customerService/config/ticket',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__config__ticket" */ '../customerService/config/ticket.js'),
            })
          : require('../customerService/config/ticket.js').default,
      },
      {
        path: '/customerService',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__index" */ '../customerService/index.js'),
            })
          : require('../customerService/index.js').default,
      },
      {
        path: '/customerService/ticket/add',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__ticket__add" */ '../customerService/ticket/add.js'),
            })
          : require('../customerService/ticket/add.js').default,
      },
      {
        path: '/customerService/ticket/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__ticket__list" */ '../customerService/ticket/list.js'),
            })
          : require('../customerService/ticket/list.js').default,
      },
      {
        path: '/customerService/ticket/:ticketId',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customerService__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/customerService/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customerService__ticket___ticketId" */ '../customerService/ticket/$ticketId.js'),
            })
          : require('../customerService/ticket/$ticketId.js').default,
      },
      {
        path: '/device/config/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__device__models__list.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/device/models/list.js').then(
                  m => {
                    return { namespace: 'list', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__device__config__list" */ '../device/config/list.js'),
            })
          : require('../device/config/list.js').default,
      },
      {
        path: '/device/group',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__device__models__list.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/device/models/list.js').then(
                  m => {
                    return { namespace: 'list', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__device__group__index" */ '../device/group/index.js'),
            })
          : require('../device/group/index.js').default,
      },
      {
        path: '/device/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__device__models__list.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/device/models/list.js').then(
                  m => {
                    return { namespace: 'list', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__device__list__index" */ '../device/list/index.js'),
            })
          : require('../device/list/index.js').default,
      },
      {
        path: '/empty',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__empty__index" */ '../empty/index.js'),
            })
          : require('../empty/index.js').default,
      },
      {
        path: '/gift/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__gift__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/gift/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__gift__config__index" */ '../gift/config/index.js'),
            })
          : require('../gift/config/index.js').default,
      },
      {
        path: '/gift/olduser',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__gift__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/gift/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__gift__olduser__index" */ '../gift/olduser/index.js'),
            })
          : require('../gift/olduser/index.js').default,
      },
      {
        path: '/guide/const',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__const__index" */ '../guide/const/index.js'),
            })
          : require('../guide/const/index.js').default,
      },
      {
        path: '/guide/introduction/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__introduction__config__index" */ '../guide/introduction/config/index.js'),
            })
          : require('../guide/introduction/config/index.js').default,
      },
      {
        path: '/guide/introduction',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__introduction__index" */ '../guide/introduction/index.js'),
            })
          : require('../guide/introduction/index.js').default,
      },
      {
        path: '/guide/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__list" */ '../guide/list.js'),
            })
          : require('../guide/list.js').default,
      },
      {
        path: '/guide/newuser/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__newuser__config__index" */ '../guide/newuser/config/index.js'),
            })
          : require('../guide/newuser/config/index.js').default,
      },
      {
        path: '/guide/newuser',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__newuser__index" */ '../guide/newuser/index.js'),
            })
          : require('../guide/newuser/index.js').default,
      },
      {
        path: '/guide/overview',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__overview" */ '../guide/overview.js'),
            })
          : require('../guide/overview.js').default,
      },
      {
        path: '/guide/product',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__guide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/guide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__guide__product" */ '../guide/product.js'),
            })
          : require('../guide/product.js').default,
      },
      {
        path: '/help/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__config" */ '../help/config.js'),
            })
          : require('../help/config.js').default,
      },
      {
        path: '/help/detail/:index',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__detail___index" */ '../help/detail/$index.js'),
            })
          : require('../help/detail/$index.js').default,
      },
      {
        path: '/help',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__index" */ '../help/index.js'),
            })
          : require('../help/index.js').default,
      },
      {
        path: '/help/questions/:categoryid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__questions___categoryid" */ '../help/questions/$categoryid.js'),
            })
          : require('../help/questions/$categoryid.js').default,
      },
      {
        path: '/help/tutorials/onecloud-cash',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__onecloud-cash" */ '../help/tutorials/onecloud-cash.js'),
            })
          : require('../help/tutorials/onecloud-cash.js').default,
      },
      {
        path: '/help/tutorials/sf',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__sf" */ '../help/tutorials/sf.js'),
            })
          : require('../help/tutorials/sf.js').default,
      },
      {
        path: '/help/tutorials/wxbox',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__wxbox" */ '../help/tutorials/wxbox.js'),
            })
          : require('../help/tutorials/wxbox.js').default,
      },
      {
        path: '/help/tutorials/wxy-cash-box',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__wxy-cash-box" */ '../help/tutorials/wxy-cash-box.js'),
            })
          : require('../help/tutorials/wxy-cash-box.js').default,
      },
      {
        path: '/help/tutorials/x86',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__x86" */ '../help/tutorials/x86.js'),
            })
          : require('../help/tutorials/x86.js').default,
      },
      {
        path: '/help/tutorials/xiaoaibox',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__tutorials__xiaoaibox" */ '../help/tutorials/xiaoaibox.js'),
            })
          : require('../help/tutorials/xiaoaibox.js').default,
      },
      {
        path: '/help/zqb',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__help__models__help.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/help/models/help.js').then(
                  m => {
                    return { namespace: 'help', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__help__zqb" */ '../help/zqb.js'),
            })
          : require('../help/zqb.js').default,
      },
      {
        path: '/income/config/device',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__config__device" */ '../income/config/device.js'),
            })
          : require('../income/config/device.js').default,
      },
      {
        path: '/income/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__config__index" */ '../income/config/index.js'),
            })
          : require('../income/config/index.js').default,
      },
      {
        path: '/income/config/indicator',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__config__indicator" */ '../income/config/indicator.js'),
            })
          : require('../income/config/indicator.js').default,
      },
      {
        path: '/income/config/tactics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__config__tactics" */ '../income/config/tactics.js'),
            })
          : require('../income/config/tactics.js').default,
      },
      {
        path: '/income/device/bare-disk',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__device__bare-disk" */ '../income/device/bare-disk.js'),
            })
          : require('../income/device/bare-disk.js').default,
      },
      {
        path: '/income/device/queue',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__device__queue" */ '../income/device/queue.js'),
            })
          : require('../income/device/queue.js').default,
      },
      {
        path: '/income/device/updating',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__device__updating" */ '../income/device/updating.js'),
            })
          : require('../income/device/updating.js').default,
      },
      {
        path: '/income/device/:userid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__device___userid" */ '../income/device/$userid.js'),
            })
          : require('../income/device/$userid.js').default,
      },
      {
        path: '/income/income-fix-strategy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__income-fix-strategy" */ '../income/income-fix-strategy.js'),
            })
          : require('../income/income-fix-strategy.js').default,
      },
      {
        path: '/income',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__index" */ '../income/index.js'),
            })
          : require('../income/index.js').default,
      },
      {
        path: '/income/indicator/chart/:userid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__indicator__chart___userid" */ '../income/indicator/chart/$userid.js'),
            })
          : require('../income/indicator/chart/$userid.js').default,
      },
      {
        path: '/income/indicator/:userid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__indicator___userid" */ '../income/indicator/$userid.js'),
            })
          : require('../income/indicator/$userid.js').default,
      },
      {
        path: '/income/list/all',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__list__all" */ '../income/list/all.js'),
            })
          : require('../income/list/all.js').default,
      },
      {
        path: '/income/list/const/chartOptions',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__list__const__chartOptions" */ '../income/list/const/chartOptions.js'),
            })
          : require('../income/list/const/chartOptions.js').default,
      },
      {
        path: '/income/list/const',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__list__const__index" */ '../income/list/const/index.js'),
            })
          : require('../income/list/const/index.js').default,
      },
      {
        path: '/income/list/sDay',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__list__sDay" */ '../income/list/sDay.js'),
            })
          : require('../income/list/sDay.js').default,
      },
      {
        path: '/income/list/:userid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__list___userid" */ '../income/list/$userid.js'),
            })
          : require('../income/list/$userid.js').default,
      },
      {
        path: '/income/ping-lost-strategy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__ping-lost-strategy" */ '../income/ping-lost-strategy.js'),
            })
          : require('../income/ping-lost-strategy.js').default,
      },
      {
        path: '/income/statistics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__statistics__index" */ '../income/statistics/index.js'),
            })
          : require('../income/statistics/index.js').default,
      },
      {
        path: '/income/statistics/:devicetype',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__statistics___devicetype" */ '../income/statistics/$devicetype.js'),
            })
          : require('../income/statistics/$devicetype.js').default,
      },
      {
        path: '/income/strategy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__strategy" */ '../income/strategy.js'),
            })
          : require('../income/strategy.js').default,
      },
      {
        path: '/income/tactics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__income__models__device.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/device.js').then(
                  m => {
                    return { namespace: 'device', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__income.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/income.js').then(
                  m => {
                    return { namespace: 'income', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__income__models__indicator.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/income/models/indicator.js').then(
                  m => {
                    return { namespace: 'indicator', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__income__tactics__index" */ '../income/tactics/index.js'),
            })
          : require('../income/tactics/index.js').default,
      },
      {
        path: '/',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__index" */ '../index.js'),
            })
          : require('../index.js').default,
      },
      {
        path: '/introduction',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__introduction__index" */ '../introduction/index.js'),
            })
          : require('../introduction/index.js').default,
      },
      {
        path: '/invite/actv2',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__actv2" */ '../invite/actv2.js'),
            })
          : require('../invite/actv2.js').default,
      },
      {
        path: '/invite/bonus',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__bonus" */ '../invite/bonus.js'),
            })
          : require('../invite/bonus.js').default,
      },
      {
        path: '/invite/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__config" */ '../invite/config.js'),
            })
          : require('../invite/config.js').default,
      },
      {
        path: '/invite/fn',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__fn" */ '../invite/fn.js'),
            })
          : require('../invite/fn.js').default,
      },
      {
        path: '/invite/info',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__info" */ '../invite/info.js'),
            })
          : require('../invite/info.js').default,
      },
      {
        path: '/invite/invitee',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__invitee" */ '../invite/invitee.js'),
            })
          : require('../invite/invitee.js').default,
      },
      {
        path: '/invite/inviter',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__inviter" */ '../invite/inviter.js'),
            })
          : require('../invite/inviter.js').default,
      },
      {
        path: '/invite/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__list" */ '../invite/list.js'),
            })
          : require('../invite/list.js').default,
      },
      {
        path: '/invite/rank',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__rank" */ '../invite/rank.js'),
            })
          : require('../invite/rank.js').default,
      },
      {
        path: '/invite/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__record" */ '../invite/record.js'),
            })
          : require('../invite/record.js').default,
      },
      {
        path: '/invite/reward',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__reward" */ '../invite/reward.js'),
            })
          : require('../invite/reward.js').default,
      },
      {
        path: '/invite/rule/helper',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__rule__helper" */ '../invite/rule/helper.js'),
            })
          : require('../invite/rule/helper.js').default,
      },
      {
        path: '/invite/rule/invitee',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__rule__invitee" */ '../invite/rule/invitee.js'),
            })
          : require('../invite/rule/invitee.js').default,
      },
      {
        path: '/invite/rule/inviter',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__rule__inviter" */ '../invite/rule/inviter.js'),
            })
          : require('../invite/rule/inviter.js').default,
      },
      {
        path: '/invite/share',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__share" */ '../invite/share.js'),
            })
          : require('../invite/share.js').default,
      },
      {
        path: '/invite/x86/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__config" */ '../invite/x86/config.js'),
            })
          : require('../invite/x86/config.js').default,
      },
      {
        path: '/invite/x86/inviter',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__inviter__index" */ '../invite/x86/inviter/index.js'),
            })
          : require('../invite/x86/inviter/index.js').default,
      },
      {
        path: '/invite/x86/inviterList/detail/:xrhzid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__inviterList__detail___xrhzid" */ '../invite/x86/inviterList/detail/$xrhzid.js'),
            })
          : require('../invite/x86/inviterList/detail/$xrhzid.js').default,
      },
      {
        path: '/invite/x86/inviterList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__inviterList__index" */ '../invite/x86/inviterList/index.js'),
            })
          : require('../invite/x86/inviterList/index.js').default,
      },
      {
        path: '/invite/x86/poster',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__poster__index" */ '../invite/x86/poster/index.js'),
            })
          : require('../invite/x86/poster/index.js').default,
      },
      {
        path: '/invite/x86/rewardDetail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invite__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invite/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invite__x86__rewardDetail__index" */ '../invite/x86/rewardDetail/index.js'),
            })
          : require('../invite/x86/rewardDetail/index.js').default,
      },
      {
        path: '/invoice/detail/:id',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invoice__models__invoice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invoice/models/invoice.js').then(
                  m => {
                    return { namespace: 'invoice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invoice__detail___id" */ '../invoice/detail/$id.js'),
            })
          : require('../invoice/detail/$id.js').default,
      },
      {
        path: '/invoice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invoice__models__invoice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invoice/models/invoice.js').then(
                  m => {
                    return { namespace: 'invoice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invoice__index" */ '../invoice/index.js'),
            })
          : require('../invoice/index.js').default,
      },
      {
        path: '/invoice/notice',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invoice__models__invoice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invoice/models/invoice.js').then(
                  m => {
                    return { namespace: 'invoice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invoice__notice__index" */ '../invoice/notice/index.js'),
            })
          : require('../invoice/notice/index.js').default,
      },
      {
        path: '/invoice/step',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__invoice__models__invoice.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/invoice/models/invoice.js').then(
                  m => {
                    return { namespace: 'invoice', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__invoice__step__index" */ '../invoice/step/index.js'),
            })
          : require('../invoice/step/index.js').default,
      },
      {
        path: '/join/community',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__join__community" */ '../join/community.js'),
            })
          : require('../join/community.js').default,
      },
      {
        path: '/join/container',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__join__container__index" */ '../join/container/index.js'),
            })
          : require('../join/container/index.js').default,
      },
      {
        path: '/join/container/rule',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__join__container__rule__index" */ '../join/container/rule/index.js'),
            })
          : require('../join/container/rule/index.js').default,
      },
      {
        path: '/logout/conditions',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__logout__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/logout/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__logout__conditions" */ '../logout/conditions.js'),
            })
          : require('../logout/conditions.js').default,
      },
      {
        path: '/logout/deal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__logout__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/logout/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__logout__deal" */ '../logout/deal.js'),
            })
          : require('../logout/deal.js').default,
      },
      {
        path: '/logout/result',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__logout__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/logout/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__logout__result" */ '../logout/result.js'),
            })
          : require('../logout/result.js').default,
      },
      {
        path: '/mall/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__mall__config" */ '../mall/config.js'),
            })
          : require('../mall/config.js').default,
      },
      {
        path: '/mall/order/:orderid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__mall__order__models__order.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/mall/order/models/order.js').then(
                  m => {
                    return { namespace: 'order', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__mall__order___orderid" */ '../mall/order/$orderid.js'),
            })
          : require('../mall/order/$orderid.js').default,
      },
      {
        path: '/mall/xcode/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__mall__xcode__models__xcode.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/mall/xcode/models/xcode.js').then(
                  m => {
                    return { namespace: 'xcode', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__mall__xcode__config" */ '../mall/xcode/config.js'),
            })
          : require('../mall/xcode/config.js').default,
      },
      {
        path: '/mall/xcode/fn',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__mall__xcode__models__xcode.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/mall/xcode/models/xcode.js').then(
                  m => {
                    return { namespace: 'xcode', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__mall__xcode__fn" */ '../mall/xcode/fn.js'),
            })
          : require('../mall/xcode/fn.js').default,
      },
      {
        path: '/mall/xcode/:prodid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__mall__xcode__models__xcode.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/mall/xcode/models/xcode.js').then(
                  m => {
                    return { namespace: 'xcode', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__mall__xcode___prodid" */ '../mall/xcode/$prodid.js'),
            })
          : require('../mall/xcode/$prodid.js').default,
      },
      {
        path: '/message/detail/:msgid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__message__models__message.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/message/models/message.js').then(
                  m => {
                    return { namespace: 'message', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__message__detail___msgid" */ '../message/detail/$msgid.js'),
            })
          : require('../message/detail/$msgid.js').default,
      },
      {
        path: '/message',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__message__models__message.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/message/models/message.js').then(
                  m => {
                    return { namespace: 'message', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__message__index" */ '../message/index.js'),
            })
          : require('../message/index.js').default,
      },
      {
        path: '/messageCenter/category/:category',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__messageCenter__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/messageCenter/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__messageCenter__category___category" */ '../messageCenter/category/$category.js'),
            })
          : require('../messageCenter/category/$category.js').default,
      },
      {
        path: '/messageCenter/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__messageCenter__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/messageCenter/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__messageCenter__config__index" */ '../messageCenter/config/index.js'),
            })
          : require('../messageCenter/config/index.js').default,
      },
      {
        path: '/messageCenter/detail/:msgID',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__messageCenter__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/messageCenter/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__messageCenter__detail___msgID" */ '../messageCenter/detail/$msgID.js'),
            })
          : require('../messageCenter/detail/$msgID.js').default,
      },
      {
        path: '/messageCenter/summary',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__messageCenter__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/messageCenter/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__messageCenter__summary" */ '../messageCenter/summary.js'),
            })
          : require('../messageCenter/summary.js').default,
      },
      {
        path: '/monitor/chart/:sn',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__monitor__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/monitor/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__monitor__chart___sn" */ '../monitor/chart/$sn.js'),
            })
          : require('../monitor/chart/$sn.js').default,
      },
      {
        path: '/monitor/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__monitor__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/monitor/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__monitor__config" */ '../monitor/config.js'),
            })
          : require('../monitor/config.js').default,
      },
      {
        path: '/monitor/userid-old',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__monitor__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/monitor/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__monitor__userid-old" */ '../monitor/userid-old.js'),
            })
          : require('../monitor/userid-old.js').default,
      },
      {
        path: '/monitor/:userid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__monitor__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/monitor/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__monitor___userid" */ '../monitor/$userid.js'),
            })
          : require('../monitor/$userid.js').default,
      },
      {
        path: '/products/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__config" */ '../products/config.js'),
            })
          : require('../products/config.js').default,
      },
      {
        path: '/products/detail/computility',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__computility" */ '../products/detail/computility.js'),
            })
          : require('../products/detail/computility.js').default,
      },
      {
        path: '/products/detail/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__config" */ '../products/detail/config.js'),
            })
          : require('../products/detail/config.js').default,
      },
      {
        path: '/products/detail/container',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__container" */ '../products/detail/container.js'),
            })
          : require('../products/detail/container.js').default,
      },
      {
        path: '/products/detail/oea',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oea" */ '../products/detail/oea.js'),
            })
          : require('../products/detail/oea.js').default,
      },
      {
        path: '/products/detail/oeaLite',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oeaLite" */ '../products/detail/oeaLite.js'),
            })
          : require('../products/detail/oeaLite.js').default,
      },
      {
        path: '/products/detail/oec',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oec" */ '../products/detail/oec.js'),
            })
          : require('../products/detail/oec.js').default,
      },
      {
        path: '/products/detail/oecTurbo',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oecTurbo" */ '../products/detail/oecTurbo.js'),
            })
          : require('../products/detail/oecTurbo.js').default,
      },
      {
        path: '/products/detail/oes',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oes" */ '../products/detail/oes.js'),
            })
          : require('../products/detail/oes.js').default,
      },
      {
        path: '/products/detail/oesPlus',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__oesPlus" */ '../products/detail/oesPlus.js'),
            })
          : require('../products/detail/oesPlus.js').default,
      },
      {
        path: '/products/detail/phonePal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__phonePal" */ '../products/detail/phonePal.js'),
            })
          : require('../products/detail/phonePal.js').default,
      },
      {
        path: '/products/detail/x86',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__x86__index" */ '../products/detail/x86/index.js'),
            })
          : require('../products/detail/x86/index.js').default,
      },
      {
        path: '/products/detail/x86Lite',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__x86Lite" */ '../products/detail/x86Lite.js'),
            })
          : require('../products/detail/x86Lite.js').default,
      },
      {
        path: '/products/detail/x86Oversea',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__x86Oversea" */ '../products/detail/x86Oversea.js'),
            })
          : require('../products/detail/x86Oversea.js').default,
      },
      {
        path: '/products/detail/zqb3pro',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__zqb3pro" */ '../products/detail/zqb3pro.js'),
            })
          : require('../products/detail/zqb3pro.js').default,
      },
      {
        path: '/products/detail/zqbLite',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail__zqbLite" */ '../products/detail/zqbLite.js'),
            })
          : require('../products/detail/zqbLite.js').default,
      },
      {
        path: '/products/detail/:productid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products__detail___productid" */ '../products/detail/$productid.js'),
            })
          : require('../products/detail/$productid.js').default,
      },
      {
        path: '/products/:productid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__products__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/products/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__products___productid" */ '../products/$productid.js'),
            })
          : require('../products/$productid.js').default,
      },
      {
        path: '/recommend/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__config__index" */ '../recommend/config/index.js'),
            })
          : require('../recommend/config/index.js').default,
      },
      {
        path: '/recommend/config/recommend-chart',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__config__recommend-chart" */ '../recommend/config/recommend-chart.js'),
            })
          : require('../recommend/config/recommend-chart.js').default,
      },
      {
        path: '/recommend',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__index" */ '../recommend/index.js'),
            })
          : require('../recommend/index.js').default,
      },
      {
        path: '/recommend/instruction',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__instruction" */ '../recommend/instruction.js'),
            })
          : require('../recommend/instruction.js').default,
      },
      {
        path: '/recommend/isp',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__isp" */ '../recommend/isp.js'),
            })
          : require('../recommend/isp.js').default,
      },
      {
        path: '/recommend/region',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recommend__models__recommend.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recommend/models/recommend.js').then(
                  m => {
                    return { namespace: 'recommend', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recommend__region" */ '../recommend/region.js'),
            })
          : require('../recommend/region.js').default,
      },
      {
        path: '/recruit/direct/apply/:id',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__apply___id" */ '../recruit/direct/apply/$id.js'),
            })
          : require('../recruit/direct/apply/$id.js').default,
      },
      {
        path: '/recruit/direct/apply-list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__apply-list__index" */ '../recruit/direct/apply-list/index.js'),
            })
          : require('../recruit/direct/apply-list/index.js').default,
      },
      {
        path: '/recruit/direct/apply-result',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__apply-result__index" */ '../recruit/direct/apply-result/index.js'),
            })
          : require('../recruit/direct/apply-result/index.js').default,
      },
      {
        path: '/recruit/direct/config/pars',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__config__pars" */ '../recruit/direct/config/pars.js'),
            })
          : require('../recruit/direct/config/pars.js').default,
      },
      {
        path: '/recruit/direct/config/recruit.config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__config__recruit.config" */ '../recruit/direct/config/recruit.config.js'),
            })
          : require('../recruit/direct/config/recruit.config.js').default,
      },
      {
        path: '/recruit/direct',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__index" */ '../recruit/direct/index.js'),
            })
          : require('../recruit/direct/index.js').default,
      },
      {
        path: '/recruit/direct/smallBox',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__smallBox" */ '../recruit/direct/smallBox.js'),
            })
          : require('../recruit/direct/smallBox.js').default,
      },
      {
        path: '/recruit/direct/x86',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__recruit__direct__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/recruit/direct/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__recruit__direct__x86" */ '../recruit/direct/x86.js'),
            })
          : require('../recruit/direct/x86.js').default,
      },
      {
        path: '/recruit/entrance',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__recruit__entrance__index" */ '../recruit/entrance/index.js'),
            })
          : require('../recruit/entrance/index.js').default,
      },
      {
        path: '/recruit/master',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__recruit__master__index" */ '../recruit/master/index.js'),
            })
          : require('../recruit/master/index.js').default,
      },
      {
        path: '/registerGuide',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__registerGuide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/registerGuide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__registerGuide__index" */ '../registerGuide/index.js'),
            })
          : require('../registerGuide/index.js').default,
      },
      {
        path: '/registerGuide/pars/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__registerGuide__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/registerGuide/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__registerGuide__pars__config" */ '../registerGuide/pars/config.js'),
            })
          : require('../registerGuide/pars/config.js').default,
      },
      {
        path: '/report/annual/agreement',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__annual__agreement" */ '../report/annual/agreement.js'),
            })
          : require('../report/annual/agreement.js').default,
      },
      {
        path: '/report/annual',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__annual__index" */ '../report/annual/index.js'),
            })
          : require('../report/annual/index.js').default,
      },
      {
        path: '/report/revenue/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__revenue__config" */ '../report/revenue/config.js'),
            })
          : require('../report/revenue/config.js').default,
      },
      {
        path: '/report/revenue/failReport',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__revenue__failReport" */ '../report/revenue/failReport.js'),
            })
          : require('../report/revenue/failReport.js').default,
      },
      {
        path: '/report/revenue/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__revenue__list" */ '../report/revenue/list.js'),
            })
          : require('../report/revenue/list.js').default,
      },
      {
        path: '/report/revenue/:reportid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__report__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/report/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__report__revenue___reportid" */ '../report/revenue/$reportid.js'),
            })
          : require('../report/revenue/$reportid.js').default,
      },
      {
        path: '/reward/online/config/effortlessReward',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__config__effortlessReward" */ '../reward/online/config/effortlessReward.js'),
            })
          : require('../reward/online/config/effortlessReward.js').default,
      },
      {
        path: '/reward/online/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__config__index" */ '../reward/online/config/index.js'),
            })
          : require('../reward/online/config/index.js').default,
      },
      {
        path: '/reward/online/effortless/rule',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__effortless__rule" */ '../reward/online/effortless/rule.js'),
            })
          : require('../reward/online/effortless/rule.js').default,
      },
      {
        path: '/reward/online/effortless/:deviceid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__effortless___deviceid" */ '../reward/online/effortless/$deviceid.js'),
            })
          : require('../reward/online/effortless/$deviceid.js').default,
      },
      {
        path: '/reward/online/faq',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__faq" */ '../reward/online/faq.js'),
            })
          : require('../reward/online/faq.js').default,
      },
      {
        path: '/reward/online',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online__index" */ '../reward/online/index.js'),
            })
          : require('../reward/online/index.js').default,
      },
      {
        path: '/reward/online/:deviceid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__reward__online__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/reward/online/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__reward__online___deviceid" */ '../reward/online/$deviceid.js'),
            })
          : require('../reward/online/$deviceid.js').default,
      },
      {
        path: '/rights/bonus',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rights__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/rights/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rights__bonus__index" */ '../rights/bonus/index.js'),
            })
          : require('../rights/bonus/index.js').default,
      },
      {
        path: '/rights/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rights__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/rights/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rights__config__index" */ '../rights/config/index.js'),
            })
          : require('../rights/config/index.js').default,
      },
      {
        path: '/rights/detail/:cardid',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rights__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/rights/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rights__detail___cardid" */ '../rights/detail/$cardid.js'),
            })
          : require('../rights/detail/$cardid.js').default,
      },
      {
        path: '/rights',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rights__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/rights/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rights__index" */ '../rights/index.js'),
            })
          : require('../rights/index.js').default,
      },
      {
        path: '/rights/welfare',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rights__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/rights/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rights__welfare__index" */ '../rights/welfare/index.js'),
            })
          : require('../rights/welfare/index.js').default,
      },
      {
        path: '/rules/cloudBean',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__cloudBean" */ '../rules/cloudBean.js'),
            })
          : require('../rules/cloudBean.js').default,
      },
      {
        path: '/rules/invite-lottery',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__invite-lottery" */ '../rules/invite-lottery.js'),
            })
          : require('../rules/invite-lottery.js').default,
      },
      {
        path: '/rules/nas',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__nas" */ '../rules/nas.js'),
            })
          : require('../rules/nas.js').default,
      },
      {
        path: '/rules/ninthAnniversary',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__ninthAnniversary" */ '../rules/ninthAnniversary.js'),
            })
          : require('../rules/ninthAnniversary.js').default,
      },
      {
        path: '/rules/userLevel',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__userLevel" */ '../rules/userLevel.js'),
            })
          : require('../rules/userLevel.js').default,
      },
      {
        path: '/rules/xlpc',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__rules__xlpc" */ '../rules/xlpc.js'),
            })
          : require('../rules/xlpc.js').default,
      },
      {
        path: '/user/cloudBean',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__cloudBean__index" */ '../user/cloudBean/index.js'),
            })
          : require('../user/cloudBean/index.js').default,
      },
      {
        path: '/user/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__config__index" */ '../user/config/index.js'),
            })
          : require('../user/config/index.js').default,
      },
      {
        path: '/user/growth',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__growth__index" */ '../user/growth/index.js'),
            })
          : require('../user/growth/index.js').default,
      },
      {
        path: '/user/level/:initLevel',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__level___initLevel" */ '../user/level/$initLevel.js'),
            })
          : require('../user/level/$initLevel.js').default,
      },
      {
        path: '/user/medal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__medal__index" */ '../user/medal/index.js'),
            })
          : require('../user/medal/index.js').default,
      },
      {
        path: '/user/welfare/:welfareType',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/user/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__welfare___welfareType" */ '../user/welfare/$welfareType.js'),
            })
          : require('../user/welfare/$welfareType.js').default,
      },
      {
        path: '/wallet/balance/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wallet__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wallet/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wallet__balance__config" */ '../wallet/balance/config.js'),
            })
          : require('../wallet/balance/config.js').default,
      },
      {
        path: '/wallet/balance/records',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wallet__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wallet/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wallet__balance__records__index" */ '../wallet/balance/records/index.js'),
            })
          : require('../wallet/balance/records/index.js').default,
      },
      {
        path: '/wallet/balance/summary',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wallet__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wallet/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wallet__balance__summary__index" */ '../wallet/balance/summary/index.js'),
            })
          : require('../wallet/balance/summary/index.js').default,
      },
      {
        path: '/wallet/deduction/:orderId',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wallet__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wallet/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wallet__deduction___orderId" */ '../wallet/deduction/$orderId.js'),
            })
          : require('../wallet/deduction/$orderId.js').default,
      },
      {
        path: '/withdraw/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw__config" */ '../withdraw/config.js'),
            })
          : require('../withdraw/config.js').default,
      },
      {
        path: '/withdraw/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw__detail" */ '../withdraw/detail.js'),
            })
          : require('../withdraw/detail.js').default,
      },
      {
        path: '/withdraw/old',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw__old" */ '../withdraw/old.js'),
            })
          : require('../withdraw/old.js').default,
      },
      {
        path: '/withdraw/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw__record" */ '../withdraw/record.js'),
            })
          : require('../withdraw/record.js').default,
      },
      {
        path: '/withdraw/rule',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw__rule" */ '../withdraw/rule.js'),
            })
          : require('../withdraw/rule.js').default,
      },
      {
        path: '/withdraw/:orderId',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__withdraw__models__withdraw.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/withdraw/models/withdraw.js').then(
                  m => {
                    return { namespace: 'withdraw', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__withdraw___orderId" */ '../withdraw/$orderId.js'),
            })
          : require('../withdraw/$orderId.js').default,
      },
      {
        path: '/wxMall/commodity/:commodityID',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__commodity___commodityID" */ '../wxMall/commodity/$commodityID.js'),
            })
          : require('../wxMall/commodity/$commodityID.js').default,
      },
      {
        path: '/wxMall/config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__config" */ '../wxMall/config.js'),
            })
          : require('../wxMall/config.js').default,
      },
      {
        path: '/wxMall/home',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__home__index" */ '../wxMall/home/index.js'),
            })
          : require('../wxMall/home/index.js').default,
      },
      {
        path: '/wxMall/order/detail/:orderID',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__order__detail___orderID" */ '../wxMall/order/detail/$orderID.js'),
            })
          : require('../wxMall/order/detail/$orderID.js').default,
      },
      {
        path: '/wxMall/order/list/order',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__order__list__order" */ '../wxMall/order/list/order.js'),
            })
          : require('../wxMall/order/list/order.js').default,
      },
      {
        path: '/wxMall/order/list/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__wxMall__models__index.js' */ '/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/pages/wxMall/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__wxMall__order__list__record" */ '../wxMall/order/list/record.js'),
            })
          : require('../wxMall/order/list/record.js').default,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404.js'),
            })
          : require('../404.js').default,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
